<template>
    <div class="cz2__checkout__atc">
        <sb-button
            v-if="isSpellingBee"
            @click="checkForProtector"
            :disabled="hasError"
            id="cz2__checkout__cta"
            variant="buy"
        >
            <span v-if="isKiosk">
                {{ $t('PRINT_TICKET') }}
            </span>
            <span v-else-if="editingFromCart">
                {{ $t('ACTION_UPDATE_CART') }}
            </span>
            <span v-else>
                {{ $t('ACTION_ADD_TO_CART') }}
            </span>
        </sb-button>
        <btn
            v-else
            primary
            onDark
            :disabled="hasError"
            @click="checkForProtector"
            id="cz2__checkout__cta"
            class="cz2__full-width cz2__full-height cz2__stationary-text-transform"
        >
            <span v-if="isKiosk">
                {{ $t('PRINT_TICKET') }}
            </span>
            <span v-else-if="editingFromCart">
                {{ $t('ACTION_UPDATE_CART') }}
            </span>
            <span v-else>
                {{ $t('ACTION_ADD_TO_CART') }}
            </span>
        </btn>
    </div>
</template>

<style lang="scss">
    @import "../style/variables.scss";
    @import "../style/shared.scss";

    #cz2.cz2 {
        .cz2__steps-options__checkout {
            .cz2__checkout__atc {
                margin: 0 auto;
                .cz2__btn {
                    pointer-events: auto;
                }

                @include respond-above(md) {
                    margin-top: var(--layout-gap);

                    width: 60%;
                }
            }
        }
    }

    #cz2.cz2.cz2__is-kiosk {
        .cz2__checkout__atc {
            width: 100%;
            .cz2__btn {
                height: 64px !important;
                font-size: 22px;
                width: 100%;
            }
        }
    }
</style>

<script>
    import Btn from './ui/Btn.vue';
    import SbButton from './SbButton.vue';

    export default {
        components: {
            Btn,
            SbButton,
        },

        computed: {
            isKiosk() {
                return this.$store.state.customizer.options.isKiosk;
            },

            viewController() {
                return this.$store.state.customizer.viewController;
            },

            hasError() {
                return this.$store.state.customizer.alertGroups.length > 0;
            },

            editingFromCart() {
                return this.$store.state.customizer.options.recipeFrom === 'cart';
            },

            protector() {
                return this.$store.getters.protector;
            },

            availableProtector() {
                return this.$store.getters.availableProtector;
            },

            isTwoPack() {
                return this.$store.getters.isTwoPack;
            },

            configurationVersion() {
                return this.$store.state.customizer.configurationVersion;
            },

            recipeOverride() {
                return this.$store.state.customizer.recipeOverride;
            },

            isSpellingBee() {
                return this.$store.state.isSpellingBee;
            },
        },

        methods: {
            checkForProtector() {
                if (this.protector || this.availableProtector == null || this.isTwoPack) {
                    this.addToCart();
                } else {
                    this.$store.dispatch('showProtectorUpsell', true);
                }
            },

            addToCart() {
                if (this.isKiosk) {
                    this.$store.dispatch('printFlow');
                } else {
                    this.$store.dispatch('trackAddToCart', {
                        controller: this.viewController,
                    });

                    this.$store.dispatch('saveRecipe', {
                        type: 'cart',
                    });
                }
            },
        },
    };
</script>
